import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { enableAccount } from "../../../services/userServices";

import styles from "./index.module.scss";

interface IEnableAccountModal {
  name?: string;
  email?: string;
  phoneNumber?: string;
  isVisible: boolean;
  onClose: () => void;
  onApproved: () => void;
}

interface IEnableAccountModalContent {
  name?: string;
  email?: string;
  phoneNumber?: string;
  onEnableAccount: () => void;
  onClose: () => void;
}

function EnableAccountModalContent({
  name,
  email,
  phoneNumber,
  onEnableAccount,
  onClose,
}: IEnableAccountModalContent) {
  return (
    <div className={styles.modalContainer}>
      <h2 className={styles.modalTitle}>
        Are you sure you want to re-enable the account?
      </h2>
      <p className={styles.modalDescription}>Account details:</p>
      {name && <p className={styles.accountInfo}>{name}</p>}
      {phoneNumber && <p className={styles.accountInfo}>{phoneNumber}</p>}
      {email && <p className={styles.accountInfo}>{email}</p>}
      <div className={styles.modalFooter}>
        <Button
          className={styles.submitButton}
          variant="success"
          size="lg"
          onClick={onEnableAccount}
        >
          Yes, re-enable
        </Button>
        <Button
          className={styles.cancelButton}
          variant="success"
          size="lg"
          onClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
}

export default function EnableAccountModal({
  name,
  email,
  phoneNumber,
  onClose,
  onApproved,
  isVisible = false,
}: IEnableAccountModal) {
  const { userId } = useParams();

  const mutation = useMutation({
    mutationFn: (userId: string) => enableAccount(userId),
    onSuccess: onApproved,
    onError: (error: Error) => {
      toast.error(
        `An error happened. Please reach out to the engineering team with the following data: error: ${error.message}, userId: ${userId}`
      );
    },
  });

  const onEnableAccount = () => {
    mutation.mutate(userId || "");
    onClose();
  };

  return (
    <Modal
      id="enableAccountModal"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={isVisible}
      onHide={onClose}
    >
      <Modal.Body>
        <EnableAccountModalContent
          name={name}
          email={email}
          phoneNumber={phoneNumber}
          onEnableAccount={onEnableAccount}
          onClose={onClose}
        />
      </Modal.Body>
    </Modal>
  );
}
